import { createFileRoute } from "@tanstack/react-router";
import { QueuesIndexPage } from "@/features/queuesindex/QueuesIndexPage";

export const Route = createFileRoute("/_app/queues/")({
  component: () => <QueuesIndexPage />,
});
